/* unplugin-vue-components disabled */import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'mine',
  components: {},
  data: function data() {
    return {
      tabs: [],
      active: 0
    };
  },
  methods: {
    onChange: function onChange(index) {
      if (!index) {
        index = 0;
      }
      this.active = index;
    },
    onClickLeft: function onClickLeft() {
      this.$router.go(-1);
    }
  },
  computed: {
    ishow: function ishow() {
      return ['ServiceMallHome', 'ServiceMallMine', 'classification', 'shoppingCart'].includes(this.$route.name);
    }
  }
};